<template>
  <sui-form-field :disabled="disabled" :width="field.width || width || 16" :required="field.required" v-if="field && !field.hidden">
    <label v-show="field.label">
      {{field.label}}
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="field.warning" v-if="field.warning"><i class="warning sign yellow fitted icon" /></span>
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="tooltip" v-if="tooltip"><i class="help circle blue fitted icon" /></span>
    </label>
    <div class="ui fluid buttons" :size="size" :vertical="vertical">
      <div class="ui button" :class="{active: $attrs.value === button.value, disabled: field.readonly, 'left labeled': button.icon}" v-for="button in buttonList" :key="button.value" @click.stop.prevent="set(button.value)">
        <i class="icon" :class="button.icon" v-if="button.icon" />
        {{button.text}}
      </div>
    </div>
    <small v-if="description">
      {{description}}
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormEntityButtons',
    mixins: [
      FormField,
    ],
    props: {
      buttons: {
        type: Array,
        required: false,
      },
      description: {
        type: String,
        required: false,
        default: '',
      },
      vertical: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        required: false,
        default: false,
      },
      size: {
        type: String,
        required: false,
        default: 'medium',
      },
    },
    computed: {
      buttonList() {
        return this.buttons || this.field.enum || []
      },
    },
  }
</script>

<style scoped>
  .tooltip { float: right; }
  .button { flex: 1!important; }
</style>
